import { inventoryMediaQueryKeys as e } from "./useInventoryMediaQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { experiencesApi as r, servicesApi as i } from "@maat/api-main";
//#region src/inventoryMedia/useFlagInventoryImageMutation.ts
var a = () => {
	let a = n();
	return t({
		mutationFn: ({ kind: e, inventoryId: t, imageId: n, reason: a }) => e === "experience" ? r.flagExperienceImage(t, n, { reason: a }) : i.flagServiceImage(t, n, { reason: a }),
		onSuccess: (t, { kind: n, inventoryId: r }) => {
			a.invalidateQueries({ queryKey: e.images(n, r) });
		}
	});
};
//#endregion
export { a as useFlagInventoryImageMutation };
